import { render, staticRenderFns } from "./uploadRecords.vue?vue&type=template&id=460c6520&scoped=true&"
import script from "./uploadRecords.vue?vue&type=script&lang=js&"
export * from "./uploadRecords.vue?vue&type=script&lang=js&"
import style0 from "./uploadRecords.vue?vue&type=style&index=0&id=460c6520&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c6520",
  null
  
)

export default component.exports